import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
// Phase C.5.1 (Candidate Language Regression): moved off hardcoded English-only step titles onto the
// centralized Text/dictionary.js architecture — see dictionary.js's wizardSteps namespace.
import { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

const { Step } = Steps;

const WIZARD_STEP_KEYS = [
  'wizardSteps.personalInfo',
  'wizardSteps.qualification',
  'wizardSteps.reservation',
  'wizardSteps.photoSignature',
  'wizardSteps.paymentSubmit'
];

// Sprint 2.4C (Candidate Journey Modernization): the candidate wizard previously had no persistent
// progress indicator once inside a step — only the wizard's landing page (HomePageSummary_new.jsx)
// shows a real antd Steps UI. Rendered from NavigationTab_new_one.jsx only when a `currentStep`
// prop is passed, so the landing page (which doesn't pass it) is unaffected.
const WizardSteps = ({ current }) => {
  const locale = getCurrentLocale();
  const displayMode = getCurrentDisplayMode();
  return (
    <Steps current={current} size="small" className="ent-wizard-steps" aria-label="Registration progress">
      {WIZARD_STEP_KEYS.map((key) => (
        <Step key={key} title={resolveText(key, locale, displayMode)} />
      ))}
    </Steps>
  );
};

WizardSteps.propTypes = {
  current: PropTypes.number.isRequired
};

export default WizardSteps;
